import { all, call, put, takeEvery } from 'redux-saga/effects';
import { CreateScheduleApi, GetAllScheduleListApi, getAdminUserApi } from '../../utils/api';
import { CREATE_SCHEDULE, GET_ALL_SCHEDULE_LIST, GET_DOCTORS_LIST } from '../storeTypes';
import { GetAllScheduleListSucess, GetDoctorsListSuccess } from '../Actions/DoctorAction';

const File = 'PatientSaga ';

function* CreateScheduleSaga(action) {
  try {
    const response = yield call(CreateScheduleApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}
function* GetAllScheduleListSaga(action) {
  try {
    const response = yield call(GetAllScheduleListApi, action.payload);
    if (response?.status === 200) {
      yield put(GetAllScheduleListSucess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* GetDoctorsListSaga(action) {
  try {
    // Call getAdminUserApi with 'Doctor' as the query parameter
    const response = yield call(getAdminUserApi, { Query: 'Doctor' });
    if (response?.status === 200) {
      // The API returns data in response.data.data (array of arrays)
      // We need to extract the first element which contains the doctors list
      const doctorsData = response?.data?.data?.[0] || [];
      yield put(GetDoctorsListSuccess(doctorsData));
    }
  } catch (error) {
    console.log(File + 'GetDoctorsListSaga Error :- ', error);
  }
}

export function* DoctorSaga() {
  yield all([
    takeEvery(CREATE_SCHEDULE, CreateScheduleSaga),
    takeEvery(GET_ALL_SCHEDULE_LIST, GetAllScheduleListSaga),
    takeEvery(GET_DOCTORS_LIST, GetDoctorsListSaga),
  ]);
}
